// TODO: Whatever is using this now should probably either live in this package or this function should live in its own package (it's quite reusable)
export var createPromiseThatResolvesViaACallback = function createPromiseThatResolvesViaACallback() {
  var resolveCommerceReCaptchaReadyPromise;
  var recaptchaReadyPromise = new Promise(function (resolve) {
    resolveCommerceReCaptchaReadyPromise = resolve;
  });
  return {
    promise: recaptchaReadyPromise,
    resolve: resolveCommerceReCaptchaReadyPromise
  };
};